import { Pipe } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe extends DatePipe {
  constructor(
    private _i18nService: I18nService
  ) {
    super(_i18nService.defaultLanguage);
  }

  transform(value: null | undefined, format?: string, timezone?: string, locale?: string): null;
  transform(value: Date | string | number | null | undefined, format?: string, timezone?: string, locale?: string): string | null;
  transform(value: string | number | Date, format?: string, timezone?: string, locale?: string): string | null {
    return super.transform(value, format, timezone, locale || this._i18nService.language);
  }
}
